import React from "react";
import { Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";

type Props = {
  trackingHostname: string;
};

/**
 * LAC-003 — preview de como o link aparece no e-mail (hostname do tenant).
 */
const SendingSetupLinkPreview = ({ trackingHostname }: Props) => {
  const { t } = useTranslation();
  const host = trackingHostname.replace(/^https?:\/\//i, "").replace(/\/$/, "");
  const samplePath = "/t/c/exemplo";
  const previewUrl = `https://${host}${samplePath}`;

  return (
    <Card className="mb-3 border-dashed">
      <CardBody>
        <h6 className="mb-1">{t("settings.sending.preview.title")}</h6>
        <p className="text-muted small mb-2">
          {t("settings.sending.preview.description")}
        </p>
        <code className="d-inline-block text-break bg-light px-2 py-1 rounded">
          {previewUrl}
        </code>
      </CardBody>
    </Card>
  );
};

export default SendingSetupLinkPreview;
